import React, { useEffect, useState } from "react";
import "./FormSection.scss";

const FormSection = ({ formData, setPostScoringDetails, setAuditConclusionTrue, auditConclusionTrue,setScoringData }) => {
  const [responses, setResponses] = useState({});


  console.log("formData", formData)
  // Initialize responses when formData is available
  useEffect(() => {
    if (formData?.length) {
      setResponses((prevResponses) => {
        const updatedResponses = { ...prevResponses };
        console.log("updated responses", updatedResponses)

        formData.forEach((section) => {
          if (updatedResponses[section.id] === undefined) {
            updatedResponses[section.id] = section.defaultText ?? "";
          }
        });

        return updatedResponses;
      });
    }
  }, [formData]);


  const checkAllValues = formData.every(item => responses[item.id]);

  useEffect(() => {
    if(checkAllValues ){
      setAuditConclusionTrue(checkAllValues)
    }else{
      setAuditConclusionTrue(false)
    }

  
  },[auditConclusionTrue,checkAllValues])

  // Handle input change
  const handleChange = (id, value) => {
    setResponses((prev) => {
      const updatedResponses = { ...prev, [id]: value };

      // Update parent component state with new responses
      setPostScoringDetails((prevDetails) => ({
        ...prevDetails,
        areaStrength: updatedResponses?.strength || "",
        areaOpportunity: updatedResponses?.opportunity || "",
        zeroFindingJustification: updatedResponses?.zero_findings || "",
      }));

      setScoringData((prev) => ({
        ...prev,
        auditConclusion: {
          ...prev.auditConclusion,
          areaStrength: {
            ...prev.auditConclusion.areaStrength,
            value: updatedResponses?.strength // Assuming updatedResponses.strength exists
          },
          areaOpportunity: {
            ...prev.auditConclusion.areaOpportunity,
            value: updatedResponses?.opportunity // Assuming updatedResponses.strength exists
          },zeroFindingJustification: {
            ...prev.auditConclusion.zeroFindingJustification,
            value: updatedResponses?.zero_findings // Assuming updatedResponses.strength exists
          }
        }
      }));

      return updatedResponses;
    });
  };

  return (
    <div className="bottom-form-section">
      {formData.map((section) => (
        <div key={section.id} style={{ marginBottom: "20px" }}>
          <label htmlFor={section.id} className="bottom-form-label">
            {section.label}
          </label>
          <textarea
            id={section.id}
            rows="2"
            // className= {!section.disable ? `editable-red bottom-from-input` : `bottom-from-input`}
            className={`w-full p-3 border border-red-600 rounded-md focus:outline-none focus:ring-2 focus:ring-red-100 autosize-textarea ${responses[section.id] ? "" : "bg-red-50"} ${!section.disable ? `editable-red` : ``}`}
            value={responses[section.id] ?? ""}
            onChange={(e) => handleChange(section.id, e.target.value)}
            disabled = {section.disable}
            
          />
        </div>
      ))}
    </div>
  );
};

export default FormSection;
